import * as _ from "lodash";
import * as log from "loglevel";
import * as React from "react";

import { inject, observer, Provider } from "mobx-react";
import { Link } from "react-router-dom";
import { Button, Checkbox, Dropdown, Grid, Icon, Pagination, Popup } from "semantic-ui-react";
import { AppStore } from "../../stores/app-store";
import { AuthStore } from "../../stores/auth-store";
import { Project } from "../../stores/models/project";
import { ProjectStore } from "../../stores/project-store";
import { ProjectDashboardLayout, Sort, UIStore } from "../../stores/ui-store";
import { UserStore } from "../../stores/user-store";
import { LoadingSpinner } from "../common/loading-spinner";
import { AddProject } from "./add-project";
import { ProjectsView } from "./projects-view";

interface IProjectDashboardProps {
	projectStore?: ProjectStore;
	uiStore?: UIStore;
	userStore?: UserStore;
	authStore?: AuthStore;
	appStore?: AppStore;
}

interface IProjectDashboardState {
	searchTerm?: string;
	statusFitlers?: string[];
	pmFilters?: string[];
}




@inject("projectStore", "uiStore", "authStore", "userStore", "appStore") @observer
export class ProjectDashboard extends React.Component<IProjectDashboardProps, IProjectDashboardState>{
	internalFilterOptions = [
		{
			"key": 1,
			"value": "New Project",
			"text": "New Project",
			"label": { "color": "blue", "empty": true, "circular": true },
		},
		{
			"key": 2,
			"value": "Configuration",
			"text": "Configuration",
			"label": { "color": "pink", "empty": true, "circular": true },
		},
		{
			"key": 11,
			"value": "Programming",
			"text": "Programming",
			"label": { "color": "purple", "empty": true, "circular": true },
		},
		{
			"key": 3,
			"value": "In Production",
			"text": "In Production",
			"label": { "color": "orange", "empty": true, "circular": true },
		},
		{
			"key": 4,
			"value": "Testing",
			"text": "Testing",
			"label": { "color": "orange", "empty": true, "circular": true },
		},
		{
			"key": 5,
			"value": "Live",
			"text": "Live",
			"label": { "color": "green", "empty": true, "circular": true },
		},
		{
			"key": 6,
			"value": "Pretest",
			"text": "Pretest",
			"label": { "color": "yellow", "empty": true, "circular": true },
		},
		{
			"key": 7,
			"value": "On Hold",
			"text": "On Hold",
			"label": { "color": "grey", "empty": true, "circular": true },
		},
		{
			"key": 8,
			"value": "Closed",
			"text": "Closed",
			"label": { "color": "black", "empty": true, "circular": true },
		},
		{
			"key": 9,
			"value": "Internal",
			"text": "Internal",
			"label": { "color": "red", "empty": true, "circular": true },
		},
		{
			"key": 10,
			"value": "Appy",
			"text": "Appy",
			"label": { "color": "green", "empty": true, "circular": true },
		},
		{
			"key": 11,
			"value": "Purged",
			"text": "Purged",
			"label": { "color": "grey", "empty": true, "circular": true },
		}
	];
	clientFilterOptions = [
		{
			"key": 3,
			"value": "In Production--New Project--Configuration--Programming--Testing",
			"text": "In Production",
			"label": { "color": "orange", "empty": true, "circular": true },
		},
		{
			"key": 5,
			"value": "Live",
			"text": "Live",
			"label": { "color": "green", "empty": true, "circular": true },
		},
		{
			"key": 6,
			"value": "Pretest",
			"text": "Pretest",
			"label": { "color": "yellow", "empty": true, "circular": true },
		},
		{
			"key": 7,
			"value": "On Hold",
			"text": "On Hold",
			"label": { "color": "grey", "empty": true, "circular": true },
		},
		{
			"key": 8,
			"value": "Closed",
			"text": "Closed",
			"label": { "color": "black", "empty": true, "circular": true },
		},
		{
			"key": 10,
			"value": "Appy",
			"text": "Appy",
			"label": { "color": "green", "empty": true, "circular": true },
		},
		{
			"key": 11,
			"value": "Purged",
			"text": "Purged",
			"label": { "color": "grey", "empty": true, "circular": true },
		}
	];
	filterOptions = null;


	constructor(props, state) {
		super(props, state);
		this.handleToggleLayout = this.handleToggleLayout.bind(this);
		this.handleToggleLayout = this.handleToggleLayout.bind(this);
		this.handleSearchChange = this.handleSearchChange.bind(this);
		this.handleSearchChangeDebounce = _.debounce(this.handleSearchChangeDebounce.bind(this), 500);
		this.handleFilterChange = this.handleFilterChange.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
		this.handlePMFilterChange = this.handlePMFilterChange.bind(this);

		this.state = { "statusFitlers": [], "pmFilters": [] };

		this.props.authStore.user.accountType !== 0 ? this.filterOptions = this.clientFilterOptions : this.filterOptions = this.internalFilterOptions;
	}

	async componentDidMount() {
		this.props.projectStore.setLoading(true);
		await this.props.appStore.loadApps();
		await this.props.projectStore.loadAccessTypes();
		await this.props.userStore.loadContactTypes();
		this.props.projectStore.setLoading(false);

		await this.props.projectStore.setOrder(this.props.uiStore.projectDashboardSort);
		await this.props.projectStore.loadMemberProjects();

		await this.props.projectStore.loadPmList();

		await this.props.uiStore.loadOptions();
		await this.props.projectStore.loadPinnedProjects(this.props.uiStore.pinnedProjects.slice().map((pin) => pin));
	}

	handleToggleLayout(layout: ProjectDashboardLayout) {
		this.props.uiStore.setProjectDashboardLayout(layout);
	}

	async handleToggleSort(sort: Sort) {
		this.props.uiStore.setProjectDashboardSort(sort);
		await this.props.projectStore.setOrder(sort, true);
	}

	handleSearchChange(e) {
		this.setState({ "searchTerm": e.target.value });
		this.props.projectStore.setSearch(e.target.value);
		this.handleSearchChangeDebounce();
	}

	handleSearchChangeDebounce() {
		this.props.projectStore.runSearch();
	}

	async handleFilterChange(e, { value }) {
		let values = value.reduce((acc, current) => {
			acc = acc.concat(current.split("--"));
			return acc;
		},                        []);
		this.setState({ "statusFitlers": values });
		await this.props.projectStore.loadMemberProjects(1, true, values, this.state.pmFilters);
	}

	async handlePMFilterChange(e, { value }) {
		this.setState({ "pmFilters": value });
		await this.props.projectStore.loadMemberProjects(1, true, this.state.statusFitlers, value);
	}

	async handlePageChange(pagination) {
		await this.props.projectStore.changePage(pagination.activePage, this.state.statusFitlers, this.state.pmFilters);
	}
	renderLabel = label => ({
		"color": label.label.color,
		"content": label.text,
		//"icon": "check",
	})

	render() {
		const { projectStore, uiStore } = this.props;

		let gridButtonClass = "toggle";
		let listButtonClass = "toggle";
		let sortAscClass = "toggle";
		let sortDescClass = "toggle";

		if (uiStore.projectDashboardLayout == ProjectDashboardLayout.grid) {
			gridButtonClass += " active";
		}
		else {
			listButtonClass += " active";
		}

		let pinnedProjects = _.orderBy(projectStore.pinnedProjects, ["surveyId"], [projectStore.order == Sort.desc ? "desc" : "asc"]);

		if (projectStore.order == Sort.asc) {
			sortAscClass += " active";
		}
		else {
			sortDescClass += " active";
		}

		let pmList = projectStore.pmList.map((item, index) => {
			return {
				"value": item.name,
				"key": index,
				"text": item.name
			};
		});

		return (
			<div>
				{projectStore.errorMessage &&
					<div className="ui red icon message">
						<i className="warning sign icon"></i>
						{projectStore.errorMessage}
					</div>
				}
				<div className="ui menu fluid borderless jibunu-blue-background search-bar">
					<div className="ui search item searchBox">
						<div className="ui large transparent icon input white jibunu-lightblue-background project-search-box" >
							<input className="prompt" type="text" placeholder="Search Projects..." onChange={this.handleSearchChange} />
							<i className="search link icon white"></i>
						</div>
					</div>

					<div className="right menu">
						{(this.props.authStore.user.hasInternalAccess()) ? <AddProject /> : <span />}

						{(this.props.authStore.user.hasInternalAccess()) ? <div className="item">
							<Dropdown text="PM" icon={{ "name": "filter", "size": "large" }} multiple search selection floating labeled button className="icon jibunu-lightblue-background project-filter" options={pmList} onChange={this.handlePMFilterChange}  />
						</div> : <span/>}
						<div className="item">
							<Dropdown text="Filters" icon={{ "name": "filter", "size": "large" }} multiple selection floating labeled button className="icon jibunu-lightblue-background project-filter" options={this.filterOptions} onChange={this.handleFilterChange} renderLabel={this.renderLabel} />
						</div>
						<div className="item">
							<div className={gridButtonClass} data-tooltip="Grid View" data-position="bottom center" onClick={() => this.handleToggleLayout(ProjectDashboardLayout.grid)}>
								<i className="grid layout icon large"></i>
							</div>
							<div className={listButtonClass} data-tooltip="List View" data-position="bottom center" onClick={() => this.handleToggleLayout(ProjectDashboardLayout.list)}>
								<i className="list layout icon large"></i>
							</div>
						</div>
						<div className="item">
							<div className={sortAscClass} data-tooltip="Sort Ascending" data-position="bottom center" onClick={() => this.handleToggleSort(Sort.asc)}>
								<i className="sort alphabet ascending icon large"></i>
							</div>
							<div className={sortDescClass} data-tooltip="Sort Descending" data-position="bottom center" onClick={() => this.handleToggleSort(Sort.desc)}>
								<i className="sort alphabet descending icon large"></i>
							</div>
						</div>
					</div>
				</div>
				<ProjectsView projects={projectStore.currentPage} pinnedProjects={pinnedProjects} statusFitlers={this.state.statusFitlers} />
				{projectStore.total === 0 && !projectStore.loading &&
					<div className="center-horz">
						<h1 className="ui header">No Projects Found</h1>
					</div>
				}
				<div style={{ "textAlign": "center", "paddingTop": "50px" }}>
					<Pagination
						activePage={projectStore.pageNumber}
						totalPages={projectStore.pageCount}
						onPageChange={(ev, pagination) => this.handlePageChange(pagination)}
						firstItem={{ "content": <Icon name="backward" /> }}
						prevItem={{ "content": <Icon name="step backward" /> }}
						nextItem={{ "content": <Icon name="step forward" /> }}
						lastItem={{ "content": <Icon name="forward" /> }}
					/>
				</div>
				{projectStore.loading && <LoadingSpinner text={"Loading Projects"} />}
			</div>
		);
	}
}





// WEBPACK FOOTER //
// ./src/views/projects/project-dashboard.tsx